<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex"
import Swal from "sweetalert2";
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Ready Orders",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
  },
  data() {
    return {
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Ready Orders",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Ready Orders",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      confirmdata:{
        name:'',
        id:''
      },
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/No",
        },
        {
          key: "name",
          sortable: true,
          label: "ITEM",
        },
        
        {
          key: "quantity",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "selling",
          sortable: true,
          label: "UNIT PRICE",
        },
        {
          key: "total_price",
          sortable: true,
          label: "TOTAL PRICE",
        },
        {
          key: "user.name",
          sortable: true,
          label: "RECORDED BY",
        },
        {
          key: "action",
          sortable: true,
          label: "ACTION",
        }
      ],
    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("sales", ["ReadyOrders","SaleSaveStatus",]),
    ...mapGetters("auth", ["MyUserPerm"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.ReadyOrders ? this.ReadyOrders.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.ReadyOrders ? this.ReadyOrders.length : 1;
  },
  methods: {
    ...mapActions({
      FetchReadyOrders: "sales/fetchReadyOrders",
      ConfirmServedOrders: "sales/Confirm_servedorders",

    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    showConfirmModal(data) {
      this.confirmdata.name = data.product;
      this.confirmdata.id = data.id;
    },
    resetConfirmOrder() {
      this.confirmdata.name = '';
      this.confirmdata.id = '';
    },
    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
      this.$bvModal.hide(modalId);
      this.resetConfirmOrder();
      });
    },
    ConfirmOrder(modalId){
        this.ConfirmServedOrders(this.confirmdata);
        this.closeModal(modalId)
    },

  },
  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
            this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  created() {
    this.FetchReadyOrders();
    setInterval(() => {
        this.FetchReadyOrders(); 
    }, 150000);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center" v-html="title"></h3>
              </div>

            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="ReadyOrders?ReadyOrders:[]"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(selling)="data">
                  {{ thousandSeperator(data.item.selling) }}
                </template>
                <template #cell(total_price)="data">
                  {{ thousandSeperator(data.item.selling*data.item.quantity) }}
                </template>
                <template #cell(action)="data">
                  <b-button
                    size="sm"
                    variant="primary"
                    v-if="MyUserPerm.confirm_servedorders == 1"
                    v-b-modal.confirm_order_modal
                    class="m-2"
                    @click="showConfirmModal(data.item)"
                    ><i class="fa fa-edit"></i>Served</b-button
                  >
                </template>
              </b-table>
               <!-- modal confirm order starts -->
    <b-modal id="confirm_order_modal" hide-footer @hidden="resetConfirmOrder">
      <template #modal-title class="text-danger"> Confirm served order for {{ confirmdata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>You are confirming this order served? Click Proceed to continue.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('confirm_order_modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-warning"
          @click="ConfirmOrder('confirm_order_modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="SaleSaveStatus"
            variant="light"
            small
            label="Confirming"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
            </div>
            <Loader  v-if="!ReadyOrders"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
